var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_1402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90211 7.70741C6.81401 7.79549 6.69453 7.84497 6.56994 7.84497C6.44536 7.84497 6.32588 7.79549 6.23778 7.70741L3.57996 5.04959C3.53508 5.00625 3.49929 4.95441 3.47467 4.89709C3.45004 4.83977 3.43708 4.77812 3.43654 4.71573C3.436 4.65335 3.44789 4.59148 3.47151 4.53374C3.49513 4.476 3.53002 4.42354 3.57413 4.37943C3.61825 4.33532 3.6707 4.30043 3.72844 4.27681C3.78618 4.25318 3.84805 4.2413 3.91043 4.24184C3.97282 4.24238 4.03447 4.25534 4.09179 4.27997C4.14911 4.30459 4.20095 4.34038 4.24429 4.38525L6.56994 6.7109L8.89559 4.38525C8.9842 4.29967 9.10288 4.25232 9.22607 4.25339C9.34926 4.25446 9.4671 4.30387 9.55421 4.39098C9.64132 4.47809 9.69073 4.59593 9.6918 4.71911C9.69287 4.8423 9.64551 4.96098 9.55993 5.04959L6.90211 7.70741Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_1402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2759,
    height: 11.2759,
    fill: "white",
    transform: "translate(0.931641 0.327881)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowImg);
export default __webpack_public_path__ + "static/media/downArrowImg.87c617d15da2420a6be0b2cab81ac846.svg";
export { ForwardRef as ReactComponent };